import { Camera } from "../render/Camera";
import type { Demo, Scene } from "./types";
import { makeWorld, floor, box } from "./helpers";

export const dominoes: Demo = {
	id: "dominoes",
	title: "Dominoes",
	blurb:
		"A chain reaction: the first domino starts tilted and gravity does the rest, toppling the row one impact at a time.",
	category: "Playground & Toys",
	build(): Scene {
		const world = makeWorld();
		floor(world, 40);

		const w = 0.22;
		const h = 1.6;
		const spacing = 0.86;
		const count = 14;
		const startX = -((count - 1) * spacing) / 2;
		for (let i = 0; i < count; i++) {
			// First domino leans into the next to kick off the cascade.
			const angle = i === 0 ? 0.32 : 0;
			box(world, startX + i * spacing, -h / 2, w, h, { angle, friction: 0.5, density: 2 });
		}

		return { world, camera: new Camera(0, -1.2, 32) };
	},
};
